import React from 'react'
import NumberFormat from 'react-number-format';
import { mascaraMoeda, mascaraPlacaVeiculo, mascaraRenavam } from './arraysUtil';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { realParaNumber } from './numberUtil';
import Select from 'react-select';
import moment from 'moment'
import validador from 'br-validations';

const isTouchDevice = () =>
  typeof window !== 'undefined' &&
  ('ontouchstart' in window || navigator.maxTouchPoints > 0);

export function required (value) {
  return value && value.length > 0 ? undefined : 'Campo obrigatório';
}

export function requiredNumeric (value) {
  return value > 0 ? undefined : 'Campo obrigatório';
}

export function requiredSelect (value) {
  return value && value.value ? undefined : 'Campo obrigatório';
}

export function validateMinutos (value) {
  const minutos = value && Number(value.split(':')[1])

  return minutos > 59 ? 'Minutos não pode ser maior que 59' : undefined;
}

export function validateHora (value) {
  const minutos = value && Number(value.split(':')[0])

  return minutos > 23 ? 'Hora não pode ser maior que 23' : undefined;
}

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
    'E-mail inválido' : undefined;

export function telefone (value) {
  if (apenasNumero(value).length !== 10 && apenasNumero(value).length !== 11) {
    return 'Telefone inválido'
  }
  return '';
}

export function ano (value) {
  if (value && !moment(value, 'YYYY', true)
    .isValid()) {
    return 'Ano inválido'
  }
  return undefined
}

export function placa(value) {
  if ((value && !(/^([A-Za-z]{3})-?\d([\d]|[A-Za-z])(\d{2})$/g.test(value)))) {
      return 'Placa inválida'
  }
  return undefined
}


export function data (value) {
  if (!moment(value, 'DD/MM/YYYY', true)
    .isValid()) {
    return 'Data inválida'
  }
  return undefined
}

export function cpfCnpj (value) {
  if (apenasNumero(value).length !== 11 && apenasNumero(value).length !== 14) {
    if (apenasNumero(value).length < 11) {
      return 'CPF inválido'
    }
    return 'CNPJ inválido'
  }
  return '';
}

export function minTamanhoCodigoEmpresa(value) {
  if(!value || value.length < 3) {
    return 'Código empresa deve haver 3 dígitos'
  }
  return undefined
}

export function apenasLetra (value) {
  const regex = /<[^>]*>|[^\w\s]/g;
  if (regex.test(value)) {
    return 'O campo não pode conter caracteres com estilos de fonte';
  }

  if(value && value.match(/[\d]/g)){
    return 'O campo não pode conter caracteres numéricos'
  }
  return undefined;
}

// Igual a apenasLetra, mas aceita letras acentuadas (á, ã, ç, õ, etc.).
// Usado no fluxo de remarcação, onde o nome do passageiro pode já estar
// cadastrado com acentuação e não deve ser bloqueado por isso.
export function apenasLetraComAcento (value) {
  const regex = /<[^>]*>|[^\p{L}\s]/u;
  if (regex.test(value)) {
    return 'O campo não pode conter caracteres com estilos de fonte';
  }

  if (value && value.match(/[\d]/g)) {
    return 'O campo não pode conter caracteres numéricos'
  }
  return undefined;
}

export function apenasNumero (value) {
  if (value) {
    return value.replace(/[^\d]/g, '');
  }
  return '';
}

export function apenasLetraENumero(value) {
  if (value) {
    return value.replace(/[^a-zA-Z0-9]/g, '');
  }
  return '';
}

export function maxValueMonetario (value) {
  let number = realParaNumber(value);
  if (isNaN(number)) {
    return 'Valor deve ser menor que R$ 1.000.000,00';
  }
  return undefined;
}

export function maxValueMonetarioPercentual (value) {
  let number = realParaNumber(value);
  if (isNaN(number)) {
    return 'Valor deve ser menor que 99,99%';
  }
  return undefined;
}

export function minTamanhoNome (value) {
  if (!value || value.length < 2) {
    return 'Quantidade de caracteres deve ser maior que 1';
  }
  return undefined;
}

export function minDocumento (value) {
  if (!value || value.length < 2) {
    return 'Quantidade de caracteres deve ser maior que 1';
  }
  return undefined;
}

export function minTamnhoCampo (value) {
  if (!value || value.length < 8) {
    return 'Quantidade de caracteres deve ser maior ou igual a 8.';
  }
  return undefined;
}

export function minTamnhoIbge (value) {
  if (!value || value.length !== 7) {
    return 'Quantidade de caracteres deve ser igual a 7.';
  }
  return undefined;
}

export function maxTamanhoNome (value) {
  if (!value || value.length > 255) {
    return 'Quantidade de caracteres deve ser menor que 255';
  }
  return undefined;
}

export function maxTamanhoCampoTipoOcorrencia(value) {
  if (!value || value.length > 50) {
    return 'Quantidade de caracteres deve ser menor que 50';
  }
  return undefined;
}

export function validarApenasNumero (value) {
  if (apenasNumero(value) !== value) {
    return 'O campo deve conter apenas números';
  }
  return '';
}

export const requiredCPF = value => {
  return (value && validador.cpf.validate(value) ? undefined : 'CPF inválido');
};

export function validarCpfCnpj (value) {
  if (apenasNumero(value).length > 11) {
    return validarCNPJ(value)
  }
  return validarCPF(value)

}

export function validarCpfCnpjInformado (value) {
  if (value) {
    if (apenasNumero(value).length > 11) {
      return validarCNPJ(value)
    }
    return validarCPF(value)
  }
}

export function validarRG(rg) {
  if (apenasLetraENumero(rg) !== rg || rg.length < 5 || rg.length > 22) {
    return 'Número do documento deve conter 5 a 22 caracteres, sem caracteres especiais e espaços em branco.';
  }
  return undefined;
}

export function validarPassaporteOutros(value) {
  if (value.length < 5 || value.length > 14) {
    return 'Documento deve conter 5 a 14 caracteres.';
  }
  return undefined;
}

export function validarCPF (cpf) {
  const cpfInvalido = 'CPF inválido!';
  if (!cpf || apenasNumero(cpf).length !== 11) {
    return cpfInvalido;
  }
  cpf = cpf.replace(/[^\d]+/g, '');

  if (cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999') {
    return cpfInvalido;
  }
  let add = 0;
  for (let i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(9))) {
    return cpfInvalido;
  }
  add = 0;
  for (let i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i);
  }
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(10))) {
    return cpfInvalido;
  }
  return undefined;
}

export function validarCPFNaoObrigatorio (cpf) {
  const cpfInvalido = 'CPF inválido!';
  if (!cpf) {
    return undefined
  }
  
  if (apenasNumero(cpf).length !== 11) {
    return cpfInvalido;
  }
  cpf = cpf.replace(/[^\d]+/g, '');

  if (cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999') {
    return cpfInvalido;
  }
  let add = 0;
  for (let i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(9))) {
    return cpfInvalido;
  }
  add = 0;
  for (let i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i);
  }
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(10))) {
    return cpfInvalido;
  }
  return undefined;
}

export function validarCNPJ (cnpj) {

  const cnpjInvalido = 'CNPJ inválido!';
  if (!cnpj || apenasNumero(cnpj).length !== 14) {
    return cnpjInvalido;
  }

  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj === '') return false;

  if (cnpj.length !== 14) {
    return cnpjInvalido;
  }

  if (cnpj === '00000000000000' ||
    cnpj === '11111111111111' ||
    cnpj === '22222222222222' ||
    cnpj === '33333333333333' ||
    cnpj === '44444444444444' ||
    cnpj === '55555555555555' ||
    cnpj === '66666666666666' ||
    cnpj === '77777777777777' ||
    cnpj === '88888888888888' ||
    cnpj === '99999999999999') {
    return cnpjInvalido;
  }

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0)) {
    return cnpjInvalido;
  }

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1)) {
    return cnpjInvalido;
  }

  return undefined;

}

export function idadeMinCriancaColo (value) {
  if (value &&
    moment()
      .diff(moment(value, 'DD/MM/YYYY'), 'years', false) > 6) {
    return 'Idade sem gratuidade';
  }

  return undefined

}

export function dataValidade (value) {
  if (!value) {
    return 'Informar validade';
  }
  if (value && moment()
    .isAfter(moment(value, 'DD/MM/YYYY')
      .subtract(1, 'day'))) {
    return 'Carteira vencida'
  }
  return undefined

}

export function idadeMinIdoso (value) {
  if (value &&
    moment()
      .diff(moment(value, 'DD/MM/YYYY'), 'years', false) < 60) {
    return 'Idade sem gratuidade';
  }

  return undefined

}

export function tamanhoPorcentagem (value) {
  if (value && value.trim().length != 5) {
    return 'Campo inválido';
  }

  return undefined;

}

export const validarIP = value =>
  value && !/^((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.|$)){4}$/.test(value)
    ? 'IP inválido'
    : undefined;


export function tamanhoNotaEmpresa(value) {
  if (value && value.trim().length !== 3) {
    return 'Campo inválido';
  }
  if (value > 5) {
    return 'Nota deve ser menor ou igual a cinco';
  }
  return undefined;
}

export function tamanhoHoraMinuto (value) {
  if (value && value.trim().length != 5) {
    return 'Campo inválido';
  }

  return undefined;

}

export function minValueMonetario (value) {
  let number = realParaNumber(value);
  if (number <= 0) {
    return 'Valor deve ser maior que R$ 0,00';
  }

  return undefined;

}

export function telefoneValidation(telefone) {
  if (!telefone) return undefined;
  telefone = telefone.replace(/\D/g, '');
  if (!(telefone.length >= 10 && telefone.length <= 11)) return 'Quantidade números incorreta';

  if (telefone.length == 11 && parseInt(telefone.substring(2, 3)) != 9) return 'Número de telefone inválido';

  for (var n = 0; n < 10; n++) {
    //um for de 0 a 9.
    //estou utilizando o metodo Array(q+1).join(n) onde "q" é a quantidade e n é o
    //caractere a ser repetido
    if (telefone == new Array(11).join(n) || telefone == new Array(12).join(n)) return 'Número de telefone inválido';
  }
  var codigosDDD = [11, 12, 13, 14, 15, 16, 17, 18, 19,
    21, 22, 24, 27, 28, 31, 32, 33, 34,
    35, 37, 38, 41, 42, 43, 44, 45, 46,
    47, 48, 49, 51, 53, 54, 55, 61, 62,
    64, 63, 65, 66, 67, 68, 69, 71, 73,
    74, 75, 77, 79, 81, 82, 83, 84, 85,
    86, 87, 88, 89, 91, 92, 93, 94, 95,
    96, 97, 98, 99];
  if (codigosDDD.indexOf(parseInt(telefone.substring(0, 2))) == -1) return 'Número do DDD inválido';
  if (telefone.length == 10 && [2, 3, 4, 5, 7].indexOf(parseInt(telefone.substring(2, 3))) == -1) return 'Número de telefone inválido';
  return undefined
}

export const renderFieldHora = ({
                           input,
                           label,
                           css,
                           max,
                           readOnly,
                           meta: {touched, error}
                         }) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <NumberFormat {...input} format="##:##"
                    className={css}
                    maxLength={max}
                    style={{borderColor: touched && error ? 'red' : ''}}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{color: 'red'}}>{error}</span>)}
    </div>
  </div>
);

export const renderField = ({
  input,
  label,
  type,
  required,
  css,
  max,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <input {...input} type={type}
             id={input.name}
             className={css}
             required={required}
             maxLength={max}
             style={{ borderColor: touched && error ? 'red' : '' }}
             disabled={readOnly}
             readOnly={readOnly}/>
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldText = ({
  input,
  label,
  type,
  css,
  max,
  readOnly,
  handleChange,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <input {...input} type={type}
             className={css}
             maxLength={max}
             onChange={handleChange || input.onChange}
             value={input.value}
             style={{ borderColor: touched && error ? 'red' : '' }}
             disabled={readOnly}
             readOnly={readOnly}/>
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldMonetarioFormulario = ({
  input,
  label,
  css,
  readOnly,
  handleChange,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <CurrencyInput
        {...input}
        className={css}
        prefix="R$" decimalSeparator=","
        value={input.value}
        thousandSeparator="."
        onChange={handleChange || input.onChange}
        disabled={readOnly}
        readOnly={readOnly}/>
      {touched
      && (error && <strong style={{
        color: 'red',
        fontSize: 10
      }}>{error}</strong>)}
    </div>
  </div>
);

export const renderFieldQuilogramasFormulario = ({
  input,
  label,
  css,
  readOnly,
  handleChange,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <CurrencyInput
        {...input}
        className={css}
        prefix="" decimalSeparator=","
        value={input.value}
        thousandSeparator="."
        onChange={handleChange || input.onChange}
        disabled={readOnly}
        readOnly={readOnly}/>
      {touched
      && (error && <strong style={{
        color: 'red',
        fontSize: 10
      }}>{error}</strong>)}
    </div>
  </div>
);


export const renderFieldSelect = ({
  input,
  placeholder,
  options,
  label,
  isClearable,
  disabled,
  menuPortalTarget,
  meta: { touched, error }
}) => {
  const opts = options || [];

  if (isTouchDevice()) {
    const currentIdx = (() => {
      if (!input.value || !input.value.value) return '';
      const idx = opts.findIndex(o => {
        const a = o.nome;
        const b = input.value.value;
        if (a && b && a.id !== undefined) return a.id === b.id;
        return a === b;
      });
      return idx >= 0 ? String(idx) : '';
    })();
    return (
      <div>
        {label ? <label className='mt-2'>{label}</label> : ''}
        <select
          id={input.name}
          name={input.name}
          disabled={disabled}
          value={currentIdx}
          onChange={e => {
            const idx = parseInt(e.target.value, 10);
            if (isNaN(idx)) { input.onChange(null); return; }
            const opt = opts[idx];
            if (opt) input.onChange({ label: opt.descricao, value: opt.nome });
          }}
          onBlur={() => input.onBlur(input.value)}
          style={{
            fontSize: 16, width: '100%', height: 35, minHeight: 32,
            border: '1px solid #e4e7ea', borderRadius: 4, cursor: 'pointer',
            backgroundColor: disabled ? '#f5f5f5' : '#fff',
            color: '#333', padding: '0 8px'
          }}
        >
          <option value="">{placeholder || 'Selecione...'}</option>
          {opts.map((elemento, i) => (
            <option key={i} value={String(i)}>{elemento.descricao}</option>
          ))}
        </select>
        {touched && error && <span style={{ color: 'red' }}>{error}</span>}
      </div>
    );
  }

  return (
    <div>
      <div>
        {label ? <label className='mt-2'>{label}</label> : ''}
        <Select {...input}
                id={input.name}
                isClearable={isClearable}
                placeholder={placeholder}
                styles={{
                  control: base => ({
                    ...base,
                    height: 35,
                    minHeight: 32,
                    fontSize: 16,
                    width: '100%',
                    borderColor: '#e4e7ea',
                    cursor: 'pointer'
                  }),
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
                menuPortalTarget={menuPortalTarget || null}
                menuPosition={menuPortalTarget ? 'fixed' : undefined}
                value={input.value || null}
                isDisabled={disabled}
                noOptionsMessage={() => ('Nenhuma opção encontrada')}
                options={opts.map(elemento => ({
                  label: elemento.descricao,
                  value: elemento.nome
                }))}
                onChange={value => input.onChange(value)}
                onBlur={() => input.onBlur(input.value)}
        />
        {touched && error && <span style={{ color: 'red' }}>{error}</span>}
      </div>
    </div>
  );
};

export const renderFieldEmail = ({
  input,
  label,
  type,
  css,
  max,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>

      <input {...input} type={type}
             className={css}
             value={input.value.toLowerCase()}
             maxLength={max}
             id={input.name}
             style={{ borderColor: touched && error ? 'red' : '' }}
             disabled={readOnly}
             readOnly={readOnly}/>
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldCheck = ({
  input,
  label,
  type,
  css,
  max,
  readOnly,
  meta: { touched, error }
}) => (


  <div className='form-group form-check'>

    <input {...input} type={type}
           className={css}
           maxLength={max}
           id={input.name}
           style={{ borderColor: touched && error ? 'red' : '' }}
           disabled={readOnly}
           readOnly={readOnly}/>
    {touched
    && (error && <span style={{ color: 'red' }}>{error}</span>)}
    <label className='form-check-label'>{label}</label>
  </div>
);

export const renderFieldCpf = ({
  input,
  label,
  css,
  max,
  readOnly,
  placeholder,
  meta: { touched, error }
}) => (
  <div>
    {label ? <label className='mt-2'>{label}</label> : ''}
    <div>
      <NumberFormat {...input} format="###.###.###-##"
                    className={css}
                    maxLength={max}
                    placeholder={placeholder}
                    id={input.name}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);


export const renderFieldMoeda = ({
  input,
  label,
  type,
  css,
  max,
  cod,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <input {...input} type={type}
             className={css}
             maxLength={max}
             value={mascaraMoeda(input.value)}
             style={{ borderColor: touched && error ? 'red' : '' }}
             disabled={readOnly || cod}
             readOnly={readOnly}/>
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldNumeros = ({
  input,
  label,
  css,
  max,
  readOnly,
  valor,
  formatacao,
  placeholder,
  meta: { touched, error }
}) => (
  <div>
    {label ? <label className='mt-2'>{label}</label> : ''}
    <div>
      <NumberFormat {...input} format={formatacao ? formatacao : '###########'}
                    className={css}
                    maxLength={max}
                    placeholder={placeholder}
                    id={input.name}
                    value={valor !== undefined ? valor : input.value}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldNumerosPorcentagem = ({
  input,
  label,
  css,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <NumberFormat {...input} format={'##.##'}
                    className={css}
                    id={input.name}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldNumerosPorcentagem2 = ({
  input,
  label,
  css,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
    <NumberFormat
      value={
        typeof input.value === 'string'
          ? input.value.replace(',', '.')
          : input.value
      }
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      allowLeadingZeros={false}
      className={css}
      id={input.name}
      readOnly={readOnly}
      isAllowed={({ floatValue }) =>
        floatValue === undefined || (floatValue > 0 && floatValue <= 100)
      }
      onValueChange={(values) => {
        input.onChange(values.floatValue);
      }}
      style={{ borderColor: touched && error ? 'red' : '' }}
    />
      {touched && error && (
        <span style={{ color: 'red' }}>{error}</span>
      )}
    </div>
  </div>
);

export const renderFieldNotaEmpresa = ({
  input,
  label,
  css,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <NumberFormat {...input} format={'#.#'}
                    className={css}
                    id={input.name}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldNumber = ({
  input,
  label,
  css,
  max,
  readOnly,
  formatacao,
  placeholder,
  meta: { touched, error }
}) => (
  <div>
    {label ? <label className='mt-2'>{label}</label> : ''}
    <div>
      <NumberFormat {...input}
                    format={formatacao}
                    placeholder={placeholder}
                    className={css}
                    id={input.name}
                    maxLength={max}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);


export const renderFieldCnpj = ({
  input,
  label,
  css,
  required,
  max,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <NumberFormat {...input}
                    format="##.###.###/####-##"
                    className={css}
                    id={input.name}
                    required={required}
                    maxLength={max}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldCpfCnpj = ({
  input,
  label,
  css,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <NumberFormat {...input}
                    format={apenasNumero(input.value).length > 11 ? '##.###.###/####-##' : '###.###.###-###'}
                    className={css}
                    id={input.name}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldDataNascimento = ({
  input,
  label,
  css,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <InputMask {...input} mask="99/99/9999" value={input.value}
                 className={css}
                 style={{ borderColor: touched && error ? 'red' : '' }}
                 readOnly={readOnly}/>

      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldPlacaVeiculo = ({
  input,
  label,
  type,
  css,
  max,
  cod,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <input {...input} type={type}
             className={css}
             maxLength={max}
             value={mascaraPlacaVeiculo(input.value)}
             style={{ borderColor: touched && error ? 'red' : '' }}
             disabled={readOnly || cod}
             readOnly={readOnly}/>
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldRenavam = ({
  input,
  label,
  type,
  css,
  max,
  cod,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <input {...input} type={type}
             className={css}
             maxLength={max}
             value={mascaraRenavam(input.value)}
             style={{ borderColor: touched && error ? 'red' : '' }}
             disabled={readOnly || cod}
             readOnly={readOnly}/>
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);


export const renderFieldTelefone = ({
  input,
  label,
  css,
  max,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <NumberFormat {...input} format="(##) #####-####"
                    className={css}
                    maxLength={max}
                    id={input.name}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldMonetario = ({
  input,
  label,
  readOnly,
  handleChange,
  meta: { touched, error }
}) => (
  <div className="row align-items-center mt-2">
    <div className='col-md-6 label-cancelamento ml-2'>
      <strong>{label}:</strong>
    </div>
    <div className='col-md-6'>
      <CurrencyInput
        {...input}
        className='form-control'
        prefix="R$" decimalSeparator=","
        value={input.value}
        allowNegative={true}
        thousandSeparator="."        
        onChangeEvent={handleChange || input.onChange}
        disabled={readOnly}
        readOnly={readOnly}/>
      {touched
      && (error && <strong style={{
        color: 'red',
        fontSize: 10
      }}>{error}</strong>)}
    </div>
  </div>
);

export const renderFieldMonetarioLabelEncima = ({
  input,
  label,
  readOnly,
  handleChange,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <CurrencyInput
        {...input}
        className='form-control'
        inputMode="text"
        autoFocus={false}
        prefix="R$" decimalSeparator=","
        value={input.value}
        allowNegative={true}
        thousandSeparator="."
        onChangeEvent={handleChange || input.onChange}
        disabled={readOnly}
        readOnly={readOnly}/>
      {touched
      && (error && <strong style={{
        color: 'red',
        fontSize: 10
      }}>{error}</strong>)}
    </div>
  </div>
);

export const renderFieldPercentLabelEncima = ({
  input,
  label,
  readOnly,
  handleChange,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <CurrencyInput
        {...input}
        className='form-control'
        decimalSeparator=","
        value={input.value}
        allowNegative={true}
        thousandSeparator="."
        maxLength="5"
        onChange={handleChange || input.onChange}
        disabled={readOnly}
        readOnly={readOnly}/>
      {touched
      && (error && <strong style={{
        color: 'red',
        fontSize: 10
      }}>{error}</strong>)}
    </div>
  </div>
);

export const renderFieldPercentual = ({
  input,
  label,
  readOnly,
  handleChange,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <CurrencyInput
        {...input}
        className='form-control'
        decimalSeparator="."
        value={input.value}
        allowNegative={false}
        onChangeEvent={handleChange || input.onChange}
        disabled={readOnly}
        readOnly={readOnly}/>
      {touched
      && (error && <strong style={{
        color: 'red',
        fontSize: 10
      }}>{error}</strong>)}
    </div>
  </div>
);

export const renderTextArea = ({
  input,
  label,
  readOnly,
  css,
  max,
  meta: { touched, error }
}) => (
  <div className='ml-2'>
    <strong className='mt-2'>{label}</strong>
    <div>
        <textarea {...input}
                  className={css}
                  inputMode="text"
                  rows='5'
                  id={input.name}
                  maxLength={max}
                  style={{ borderColor: touched && error ? 'red' : '' }}
                  disabled={readOnly}
                  readOnly={readOnly}/>
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>);

export const renderTextArea2 = ({
                                 input,
                                 label,
                                 readOnly,
                                 css,
                                 max,
                                 meta: { touched, error }
                               }) => (
    <div>
      <span className='mt-2'>{label}</span>
      <div>
        <textarea {...input}
                  className={css}
                  rows='5'
                  id={input.name}
                  maxLength={max}
                  style={{ borderColor: touched && error ? 'red' : '' }}
                  disabled={readOnly}
                  readOnly={readOnly}/>
        {touched
        && (error && <span style={{ color: 'red' }}>{error}</span>)}
      </div>
    </div>);

export const renderFieldCep = ({
  input,
  label,
  css,
  max,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <NumberFormat {...input} format="#####-###"
                    className={css}
                    maxLength={max}
                    style={{ borderColor: touched && error ? 'red' : '' }}
                    readOnly={readOnly}
      />
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export const renderFieldKM = ({
                                input,
                                label,
                                readOnly,
                                handleChange,
                                meta: { touched, error }
                              }) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <CurrencyInput
        {...input}
        className='form-control'
        decimalSeparator=","
        value={input.value}
        allowNegative={true}
        thousandSeparator="."
        onChange={handleChange || input.onChange}
        disabled={readOnly}
        readOnly={readOnly}/>
      {touched
      && (error && <strong style={{
        color: 'red',
        fontSize: 10
      }}>{error}</strong>)}
    </div>
  </div>
);

export const renderFieldUpload = ({
                                input,
                                handleChange, titulo,
                                meta: { touched, error }
                              }) => (
  <div>
    <div className='input-wrapper'>
      <label htmlFor='input-file'>
        {titulo}
      </label>
      <input {...input} id='input-file' type='file' value='' accept="image/*" onChange={handleChange}/>
      <span id='file-name'/>
      {touched
      && (error && <strong style={{
        color: 'red',
        fontSize: 10
      }}>{error}</strong>)}
    </div>
  </div>
);

export const renderCombo = ({ input, label, meta: { touched, error }, options, css }) => (
    <div className="form-group">
      {label && <label>{label}</label>}
      <select {...input} className={css || 'form-control'}>
        <option value="">Selecione...</option>
        {options.map((opt, idx) => (
            <option key={idx} value={opt.value}>
              {opt.label}
            </option>
        ))}
      </select>
      {touched && error && <span className="text-danger">{error}</span>}
    </div>
);
